module.exports = __webpack_public_path__ + "img/manda_001.025870c1.png";